// Safe arithmetic parser for the transaction amount field. NO eval().
// Supports + - * / (× ÷), unary +/-, Indonesian formatting (dot = thousands,
// comma = decimal). Recursive-descent with correct precedence.
//
// evalExpression(text) -> { ok, value } | { ok:false, empty } | { ok:false, error }
//   error: "invalid" | "divzero"

export function evalExpression(input) {
  if (input == null) return { ok: false, empty: true };
  let s = String(input).trim();
  if (!s) return { ok: false, empty: true };

  // Normalize: operator glyphs, whitespace, Indonesian separators.
  s = s.replace(/×/g, "*").replace(/÷/g, "/");
  s = s.replace(/\s+/g, "");
  s = s.replace(/\./g, ""); // thousand separators
  s = s.replace(/,/g, "."); // decimal comma -> dot

  if (!/^[0-9+\-*/.]+$/.test(s)) return { ok: false, error: "invalid" };

  let i = 0;
  let divByZero = false;

  const parseNumber = () => {
    const start = i;
    while (i < s.length && /[0-9.]/.test(s[i])) i++;
    const num = s.slice(start, i);
    if (num === "" || num === "." || (num.match(/\./g) || []).length > 1) return NaN;
    const v = Number(num);
    return Number.isFinite(v) ? v : NaN;
  };

  const parseFactor = () => {
    if (s[i] === "-") { i++; return -parseFactor(); }
    if (s[i] === "+") { i++; return parseFactor(); }
    return parseNumber();
  };

  const parseTerm = () => {
    let v = parseFactor();
    if (Number.isNaN(v)) return NaN;
    while (s[i] === "*" || s[i] === "/") {
      const op = s[i++];
      const r = parseFactor();
      if (Number.isNaN(r)) return NaN;
      if (op === "/") {
        if (r === 0) { divByZero = true; return NaN; }
        v = v / r;
      } else v = v * r;
    }
    return v;
  };

  const parseExpr = () => {
    let v = parseTerm();
    if (Number.isNaN(v)) return NaN;
    while (s[i] === "+" || s[i] === "-") {
      const op = s[i++];
      const r = parseTerm();
      if (Number.isNaN(r)) return NaN;
      v = op === "+" ? v + r : v - r;
    }
    return v;
  };

  const result = parseExpr();
  if (divByZero) return { ok: false, error: "divzero" };
  if (Number.isNaN(result) || i !== s.length) return { ok: false, error: "invalid" };
  return { ok: true, value: result };
}
